<template>
    <div>
        <CustomTable
            :items.sync="tables.fieldMapping.items"
            :fields="traslateLabels(tables.fieldMapping.fields)"
            v-bind="tables.fieldMapping"
        >
            <template #key="{ index }">
                <SelectFields
                    :value.sync="tables.fieldMapping.items[index].key"
                    :placeholder="$t('Select a field')"
                    size="sm"
                    class="mb-0"
                    :advanceMode="true"
                    uses="DELIVERY"
                    optionsValue="name"
                />
            </template>
            <template #name="{ index }">
                <CInput
                    :value.sync="tables.fieldMapping.items[index].name"
                    :placeholder="$t('enter_the_value')"
                    :invalidFeedback="$t('value_is_required')"
                    class="mb-0"
                    size="sm"
                />
            </template>
            <template #options="{ index }">
                <div class="table-options">
                    <CButton
                        color="success"
                        variant="outline"
                        square
                        size="sm"
                        @click="toggleDetails('fieldMapping', index)"
                    >
                        <CIcon
                            class="icon"
                            :content="$options.icons.cilPencil"
                        />
                    </CButton>
                    <ButtonTrash
                        @click="deleteItemToTable('fieldMapping', index)"
                    />
                </div>
            </template>
            <template #details="{ index, item }">
                <CCollapse :show="Boolean(item._toggled)">
                    <CContainer :fluid="true">
                        <CRow>
                            <CCol col="3">
                                <CInputCheckbox
                                    :checked.sync="
                                        tables.fieldMapping.items[index].format
                                            .active
                                    "
                                    :label="$t('enable_formatting')"
                                />
                                <CSelect
                                    :value.sync="
                                        tables.fieldMapping.items[index].format
                                            .type
                                    "
                                    :options="
                                        traslateLabels(
                                            $options.options.MappingFormatType
                                        )
                                    "
                                    :label="$t('Action')"
                                    :placeholder="$t('Select an action')"
                                    size="sm"
                                />
                            </CCol>
                            <CCol col="9">
                                <CInput
                                    v-if="
                                        tables.fieldMapping.items[index].format
                                            .type == 'mask'
                                    "
                                    :value.sync="
                                        tables.fieldMapping.items[index].format
                                            .mask
                                    "
                                    :label="$t('apply_mask')"
                                    :placeholder="$t('enter_the_mask')"
                                    size="sm"
                                />
                                <CSelect
                                    v-else-if="
                                        tables.fieldMapping.items[index].format
                                            .type == 'format_date' ||
                                        tables.fieldMapping.items[index].format
                                            .type == 'now'
                                    "
                                    :value.sync="
                                        tables.fieldMapping.items[index].format
                                            .formatDate
                                    "
                                    :options="$options.options.DateFormat"
                                    :label="$t('date_format')"
                                    :placeholder="$t('select_a_date_format')"
                                    size="sm"
                                />
                            </CCol>
                        </CRow>
                    </CContainer>
                </CCollapse>
            </template>
            <template #no-items-view>
                <div class="block-no-items section">
                    <h2 class="section__title text-no-items">
                        {{ $t("add_field_mapping") }}
                    </h2>
                    <ButtonAdd
                        @click="addItemToTable('fieldMapping', null, defaultMappingFieldItem)"
                        v-if="tables.fieldMapping.items.length == 0"
                    />
                </div>
            </template>
            <template #under-table>
                <ButtonAdd
                    @click="addItemToTable('fieldMapping', null, defaultMappingFieldItem)"
                    v-if="tables.fieldMapping.items.length > 0"
                />
            </template>
        </CustomTable>
    </div>
</template>

<script>
/**Components */
import ButtonAdd from "~/components/ButtonAdd.vue";
import ButtonTrash from "~/components/ButtonTrash.vue";
import SelectFields from "£lement/SelectFields";
import CustomTable from "~/components/CustomTable";

/** Mixins */
import tableMixin from "~/mixins/table.js";
import traslateMixin from "~/mixins/traslate.js";

/** Others */
import {
    cilSave,
    cilArrowThickFromRight,
    cilSettings,
    cilPencil,
    cilTrash,
    cilPlus,
} from "@coreui/icons";
import FilterTypeOptions from "~/pages/app/config/options/filter_type";
import MappingFormatType from "~/assets/options/mapping_format_type.json";
import DateFormat from "~/assets/options/date_format.json";

export default {
    name: "TableMappingFields",
    mixins: [traslateMixin, tableMixin],
    icons: {
        cilSave,
        cilArrowThickFromRight,
        cilSettings,
        cilPencil,
        cilTrash,
        cilPlus,
    },
    options: {
        FilterTypeOptions,
        MappingFormatType,
        DateFormat,
    },
    components: {
        SelectFields,
        CustomTable,
        ButtonAdd,
        ButtonTrash,
    },
    data() {
        return {
            tables: {
                fieldMapping: {
                    items: [],
                    fields: [
                        {
                            key: "key",
                            label: "key",
                            sorter: false,
                            filter: false,
                            _style: "width:30%",
                        },
                        {
                            key: "name",
                            label: "name",
                            sorter: false,
                            filter: false,
                            _style: "width:30%",
                        },
                        {
                            key: "options",
                            label: "options",
                            sorter: false,
                            filter: false,
                            _style: "width:10%",
                        },
                    ],
                    loading: false,
                },
            },
            defaultMappingFieldItem: {
                key: null,
                name: null,
                format: {
                    active: false,
                    type: null,
                    mask: null,
                    formatDate: null
                }
            },
            modals: {},
            modelFields: [],
        };
    },
    props: {
        value: {
            type: Array | Object,
            default: () => {
                return [];
            },
        },
    },
    watch: {
        "tables.fieldMapping.items": {
            handler(newValue) {
                this.$emit("update:value", newValue);
                this.$emit("change", newValue);
            },
            deep: true,
        },
        value(newValue) {
            if (Array.isArray(newValue)) {
                this.tables.fieldMapping.items = newValue;
            }
        },
    },
    methods: {
        addToggleAttrToItems(items) {
            return items.map(function (item) {
                if (!item._toggled) {
                    item = {
                        ...item,
                        _toggled: false,
                    };
                }
                return item;
            });
        },
    },
    mounted() {
        if (Array.isArray(this.value)) {
            this.tables.fieldMapping.items = this.addToggleAttrToItems(
                this.value
            );
        }
    },
};
</script>

<style>
</style>